import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgNoticeableIrritationEmojiSecondary from './svgs/NoticeableIrritationEmojiSecondary.js';
import SvgNoticeableIrritationEmoji from './svgs/NoticeableIrritationEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var noticeableIrritationEmoji = (props => useIcon(SvgNoticeableIrritationEmoji, SvgNoticeableIrritationEmojiSecondary, props));

export { noticeableIrritationEmoji as default };
